(function(){
  'use strict';

  // Mobile nav toggle
  var navToggleBtn = document.querySelector('[data-menu-toggle]');
  var siteNav = document.getElementById('SiteNav');

  function setNavOpen(open){
    if(!siteNav || !navToggleBtn) return;
    siteNav.classList.toggle('is-open', open);
    navToggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('nav-open', open);
  }

  if(navToggleBtn && siteNav){
    navToggleBtn.addEventListener('click', function(){
      setNavOpen(!siteNav.classList.contains('is-open'));
    });
    siteNav.addEventListener('click', function(e){
      if(e.target.closest('a')) setNavOpen(false);
    });
  }

  // Tab filter for catalog grid
  document.querySelectorAll('[data-filter-bar]').forEach(function(bar){
    var grid = bar.parentElement.querySelector('[data-product-grid]');
    if(!grid) return;
    bar.addEventListener('click', function(e){
      var btn = e.target.closest('[data-filter]');
      if(!btn) return;
      bar.querySelectorAll('.is-active').forEach(function(b){b.classList.remove('is-active')});
      btn.classList.add('is-active');
      var f = btn.dataset.filter;
      grid.querySelectorAll('.catalog__item').forEach(function(item){
        var tags = (item.dataset.tags || '').toLowerCase();
        item.classList.toggle('is-hidden', f !== 'all' && tags.indexOf(f) === -1);
      });
    });
  });

  // Cart drawer
  var drawer = document.getElementById('cart-drawer');
  function openDrawer(){ if(drawer){ drawer.hidden = false; document.body.style.overflow='hidden'; } }
  function closeDrawer(){ if(drawer){ drawer.hidden = true; document.body.style.overflow=''; } }
  document.querySelectorAll('[data-cart-open]').forEach(function(el){
    el.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); refreshCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function(el){
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      closeDrawer();
      setNavOpen(false);
    }
  });

  function renderDrawerSection(sectionsData){
    var body = document.querySelector('[data-cart-body]');
    if(!body || !sectionsData) return;
    var html = sectionsData['cart-drawer-contents'];
    if(html){
      // Section Rendering API returns the full <div class="shopify-section">...</div> wrapper
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('.shopify-section');
      body.innerHTML = inner ? inner.innerHTML : html;
    }
  }

  function updateCount(cart){
    var count = document.querySelector('[data-cart-count]');
    if(count && cart) count.textContent = cart.item_count;
  }

  function refreshCart(){
    fetch(window.location.pathname + '?sections=cart-drawer-contents', { headers: { 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(renderDrawerSection)
      .catch(function(){});

    fetch('/cart.js', { headers: { 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(updateCount)
      .catch(function(){});
  }

  // Add to cart
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer-contents');
    var btn = form.querySelector('[type=submit]');
    if(btn) btn.disabled = true;
    fetch('/cart/add.js', { method:'POST', body: fd, headers: {'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(btn) btn.disabled = false;
        if(data.sections) renderDrawerSection(data.sections);
        openDrawer();
        fetch('/cart.js', { headers: { 'Accept':'application/json' } })
          .then(function(r){ return r.json(); })
          .then(updateCount)
          .catch(function(){});
      })
      .catch(function(){ if(btn) btn.disabled = false; form.submit(); });
  });
})();